<template>
  <div class="allienceActiveReport">
    <div class="content" v-html="datas">
      <!-- <div class="first-line">{{datas.title}}</div>
      <div class="second-line">
        <span>{{datas.times | times}}</span>
        <span @click="zans">
          <img :src="zan.show==true? zan.zanImg :zan.zanImg1" alt />
          {{datas.praise}}
        </span>
        <span @click="collects">
          <img :src="collect.show==true? collect.collectImg : collect.collectImg1" alt />
          {{datas.collect}}
        </span>
      </div>
      <div class="second-line">{{datas.content}}</div>-->
    </div>
    <div class="just-report" @click="FmotaiShow">{{buttonText}}</div>
    <div class="motai" v-if="motaiShow">
      <div class="report">
        <img src="@/assets/index/partyAllience/active/dp-sy-lm21.png" alt />
        <div class="input-template" style="top:4.5rem;">
          <span>姓名:</span>
          <el-input placeholder="请输入姓名" v-model="name" clearable></el-input>
        </div>
        <div class="input-template" style="top:5.5rem;">
          <span>电话:</span>
          <el-input placeholder="请输入电话" v-model="phone" clearable type="number"></el-input>
        </div>
        <div class="input-template" style="top:6.5rem">
          <span>公司名称:</span>
          <el-input placeholder="请输入公司名称" v-model="company" clearable></el-input>
        </div>
        <div class="submit" style="top:8rem;">
          <button @click="report">确认提交</button>
        </div>
        <div class="icon" style="bottom:-.7rem;" @click="motaiShow=false">
          <i class="el-icon-circle-close"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      datas: '',
      url: "/getNewsDetail",
      newsId: "",
      collect: {
        collectImg1: require("@/assets/public/dq-shoucang1@2x.png"),
        collectImg: require("@/assets/public/dq-shoucang@2x.png"),
        name1: "已收藏",
        name: "收藏",
        show: true
      },
      zan: {
        zanImg1: require("@/assets/public/dq-zan1@2x.png"),
        zanImg: require("@/assets/public/dq-zan@2x.png"),
        name1: "已赞",
        name: "赞",
        show: true
      },
      name: "",
      phone: "",
      company: "",
      motaiShow: false,
      id: 0,
      receivetime: '',
      buttonText: "立即报名"
    };
  },
  mounted: function() {
    const { receivetime, id, memo } = this.$route.query
    this.id = id
    this.receivetime = receivetime
    this.datas = memo
    this.getMsg();
  },
  methods: {
    getMsg() {
      // let time = this.$route.query.slide.receivetime
      // if (time == undefined) this.$router.go(-1);
      let data = new Date();
      if (new Date(this.receivetime) < data) {
        this.buttonText = "报名已结束";
      }
    },
    report() {
      if (this.name != "" && this.phone != "" && this.company != "") {
        this.axios
          .post("/api/Main/AddMessage", {
            name: this.name,
            phone: this.phone,
            company: this.company,
            id: this.id
          })
          .then(e => {
            // console.log(e.data);
            if (e.data.code == 0) {
              alert("添加成功");
              this.buttonText = "已报名成功";
              this.motaiShow = false;
            } else [alert(e.data.msg)];
          })
          .catch(err => {
            console.log("err", err);
          });
      }
    },
    zans() {},
    collects() {},
    sees() {},
    FmotaiShow() {
      if (this.buttonText == "报名已结束") return;
      else this.motaiShow = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.allienceActiveReport {
  .motai {
    .report {
      .icon {
        text-align: center;
        position: absolute;
        width: 100%;
        font-size: 0.6rem;
        color: #fff;
      }
      .submit {
        text-align: center;
        button {
          width: 2.4rem;
          height: 0.68rem;
          background-image: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%),
            linear-gradient(#eb7d14, #eb7d14);
          border-radius: 0.34rem;
          border: 0;
          font-size: 0.3rem;
          color: #fff;
        }
        position: absolute;
        width: 100%;
      }
      .input-template {
        span {
          width: 30%;
          text-align: center;
        }
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: absolute;
        width: 96%;
      }
      img {
        width: 100%;
      }
      width: 80%;
      margin: 10vh auto;
      position: relative;
    }
    position: fixed;
    height: 100vh;
    width: 100%;
    top: 0;
    background: rgba($color: #000000, $alpha: 0.2);
  }
  .content {
    width: 94%;
    margin: 0 auto;
    padding-bottom: 1rem;
  }
  .just-report {
    position: fixed;
    bottom: 0;
    line-height: 3;
    background-image: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%),
      linear-gradient(#ffa000, #ffa000);
    text-align: center;
    width: 100%;
    color: #fff;
  }
  background: #fff;
  padding-top: 1rem;
  font-size: 0.3rem;
  min-height: 100vh;
}
</style>

<style lang="scss">
.allienceActiveReport {
  .content {
    img {
      width: 100%;
    }
  }
}
</style>
